export default "__VITE_ASSET__BayQJMZk__"